import { Dialog, DialogContent, DialogTitle, MenuItem, Select } from "@mui/material";
import { RadioBtnDialogModel } from "../../Utilities/Models/ConstantModels";
import "./RadioBtnDialog.scss";
import close from "../../../Assets/bulkUploadDialog/close.svg";
import { useEffect, useState } from "react";
import { axiosInstance } from "../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../Utilities/Constants/ApiEndpoints";
import {
    API_RESPONSE,
  LANGUAGES,
  LAYOUTS,
} from "../../Utilities/Constants/Constants";
import { useSelector } from "react-redux";
import Radio from '@mui/joy/Radio';
import RadioGroup from '@mui/joy/RadioGroup';


const RadioBtnDialog = (dialogData: RadioBtnDialogModel) => {
  const { isOpen, onCloseDialog, uploadType } = dialogData;
  const [hasError, setHasError] = useState(false);
  const [filterValues, setFilterValues] = useState<any>([])


  const language: any = useSelector((state: any) => {
    return state.languageReducer.language;
  });

  const handleOnChangeRadio = (event:any)=>{
    const nextValues = [...filterValues]
    const updatedNextValues = nextValues.map((item) => ({...item, is_enable: item.id == event.target.value ? true: false}) )
    setFilterValues(updatedNextValues)
  }

  const handleSubmit = () => {
    const newval = filterValues.find((fv:any)=> fv.is_enable)
    postFilterdetails(newval)
    onCloseDialog()
  }

  useEffect(() => {
    getFilterdetails()
  }, [dialogData])

  

const getFilterdetails =() => {
    axiosInstance
    .get(API_END_POINTS.THEMEPARK_TRENDING_FILTER)
    .then((response:any) => {
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
            setFilterValues(response.data.result.data)
            
        }
  })}
  
  const postFilterdetails =(payload:any) => {
    axiosInstance
    .post(API_END_POINTS.THEMEPARK_TRENDING_FILTER, payload)
    .then((response:any) => {
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
            console.log(response.data.result.data)
            
        }
  }).catch(()=>{})
}

  const closeDialog = () => {
    setHasError(false);
  };
  return (
    <>
      <Dialog
        onClose={() => {
          closeDialog();
          onCloseDialog();
        }}
        open={isOpen}
        dir={language === LANGUAGES.ENGLISH ? LAYOUTS.LTR : LAYOUTS.RTL}
        className="bulk_upload_dialog_wrapper"
      >
        <DialogTitle className="close_wrapper">
          <img
            onClick={() => {
              closeDialog();
              onCloseDialog();
            }}
            src={close}
            alt="Learn and Play"
          />
          <div className="upload_files_title">{"Choose The Method To show The Theme Park List On Trending"}</div>
        </DialogTitle>
          <DialogContent>
          <RadioGroup name="radio-buttons-group" onChange={handleOnChangeRadio} >
                {filterValues.map((item: any, i:number) => {
                    return (
                        <Radio key={i} value={item.id} size="lg" label={item.filter_logic} variant="outlined" checked={item.is_enable}/>
                    )
                })}
            </RadioGroup>
            <button
            className="col-md-6 p-2 mt-4 btn btn-secondary m-1"
            onClick={handleSubmit}
            >
            Submit
            </button>
            
          </DialogContent>
      </Dialog>
    </>
  );
};
export default RadioBtnDialog;
